import { useQuery } from '@tanstack/react-query'
import { api, ApiHttpError } from '~/lib/api/client'
import type { SystemStatus } from '~/lib/api/types'

export const SYSTEM_STATUS_QUERY_KEY = ['system-status'] as const

export function useSystemStatus() {
  return useQuery<SystemStatus, ApiHttpError>({
    queryKey: SYSTEM_STATUS_QUERY_KEY,
    queryFn: () => api.getSystemStatus(),
    refetchOnWindowFocus: true,
    staleTime: 30 * 1000,
  })
}
